const $ = jQuery;
const $appointmentTool = $('#appointment-tool');

export default function (removeLoader = false) {
    if ($appointmentTool.length > 0) {
        if (removeLoader) {
            $appointmentTool.removeClass('loading');
        } else {
            $appointmentTool.addClass('loading');
        }
    }
}
